import React from "react";

interface TuyaLogoProps {
  size?: "navbar" | "app" | "card";
}

export const TuyaLogo: React.FC<TuyaLogoProps> = ({ size = "navbar" }) => {
  const sizeClasses = {
    navbar: "w-5 h-5",
    app: "w-8 h-8",
    card: "w-6 h-6",
  };

  return (
    <div className={`${sizeClasses[size]} flex items-center justify-center`}>
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        {/* Tuya Logo - Smart Home Platform */}
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
        <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" />
        <circle cx="12" cy="12" r="2" />
      </svg>
    </div>
  );
};
